import LightGallery from 'lightgallery/react';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import {LightGalleryLicence} from "../../utils/constants";
import React from 'react';

const GalleryWrapper = ({children, ...props}) => {
  return (
    <LightGallery speed={500} licenseKey={LightGalleryLicence} plugins={[lgThumbnail, lgZoom]} {...props}>
      {children}
    </LightGallery>
  );
}

export default React.memo(GalleryWrapper);
